import { navigate } from 'gatsby';
import React, { Fragment, useEffect, useState } from 'react';

import UI from '#front-credpago';

import { apiSlim } from '../../../services/api';
import useResizer from '../../../utils/useResizer';
import { Layout } from '../../index';
import listQuestions from './questions';
import * as S from './styles';

const Questions = ({ idPerson }) => {
  const isMobile = useResizer();
  const [message, setMessage] = useState({
    text: '',
  });
  const [error, setError] = useState(false);
  const [sendingData, setSendingData] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [questions, setQuestions] = useState({
    question1Radio: '',
    question1Text: '',
    question2Radio: '',
    question3Radio: '',
    question4Radio: '',
    question4Text: '',
    question5Radio: '',
    observation: '',
  });

  useEffect(() => {
    if (!idPerson) {
      navigate('/');
    }
  }, []);

  const handleChange = (name, value) => {
    setQuestions((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setError(false);
  };

  const nextQuestion = () => {
    if (currentQuestion < 6) {
      let error = false;

      if (currentQuestion === 1 && questions.question1Radio === '') {
        error = true;
      }

      if (currentQuestion === 2 && questions.question2Radio === '') {
        error = true;
      }

      if (currentQuestion === 3 && questions.question3Radio === '') {
        error = true;
      }

      if (currentQuestion === 4 && questions.question4Radio === '') {
        error = true;
      }

      if (currentQuestion === 5 && questions.question5Radio === '') {
        error = true;
      }

      if (currentQuestion === 6 && questions.observation === '') {
        error = true;
      }

      if (error) {
        setError(true);
      } else {
        setCurrentQuestion(currentQuestion + 1);
      }
    }
  };

  const backQuestion = () => {
    if (currentQuestion > 1) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const handleSubmit = async () => {
    setSendingData(true);

    const params = {
      id_pessoa: btoa(idPerson),
      indicar: questions.question2Radio,
      opiniao: questions.observation,
      motivo_cancelamento: questions.question1Radio,
      motivo_cancelamento_outros: questions.question1Text,
      nivel_satisfacao_locacao: questions.question3Radio,
      problemas_enfrentados: questions.question4Radio,
      problemas_enfrentados_outros: questions.question4Text,
      nivel_satisfacao_atendimento_imobiliaria: questions.question5Radio,
    };

    try {
      setMessage({ type: '', loading: true });

      const response = await apiSlim.post('marketing/pesquisa_cancelamento/', params);

      if (response) {
        setSendingData(false);
        setMessage({
          text: true,
        });

        return;
      }

      setMessage({
        text: false,
      });
    } catch (error) {
      setMessage({
        text: false,
      });
    }
  };

  return (
    <Layout internal={true}>
      <S.Container>
        <S.Wrapper>
          <UI.Title
            level={1}
            fontWeight={700}
            splitLabel={['Pesquisa de ', 'Cancelamento']}
            style={{ textAlign: 'center', marginBottom: 15 }}
          />

          <S.CustomDescription color="gray">
            A CredPago nasceu tornar a vida das pessoas muito mais prática facilitando o acesso a moradia e levar mais
            negócios para imobiliárias. <br /> Por isso, queremos saber como foi a sua experiência com os nossos
            serviços. Responda a nossa Pesquisa de Cancelamento.
          </S.CustomDescription>

          {message.text ? (
            <>
              <S.WrapperConfirmation>
                <UI.Description color="gray" style={{ textAlign: 'center' }}>
                  Muito obrigado por responder nossa Pesquisa de Satisfação.
                </UI.Description>

                <S.AlertWrapper style={{ marginTop: 30 }}>
                  <UI.Alert message="Iremos analisar sua resposta com muito carinho!" type="success" />
                </S.AlertWrapper>
              </S.WrapperConfirmation>
            </>
          ) : (
            <>
              <S.WrapperQuestion>
                {listQuestions.equalQuestion.map((question) => {
                  if (currentQuestion === question.id) {
                    return (
                      <Fragment key={question.id}>
                        <UI.Title
                          level={3}
                          fontWeight={700}
                          label={question.title}
                          style={{
                            textAlign: 'center',
                            marginTop: 30,
                            marginBottom: 15,
                          }}
                        />
                        <S.WrapperRadios>
                          <UI.Radio
                            radios={question.radios}
                            value={questions[question.valueRadio]}
                            onChange={(e) => handleChange(question.valueRadio, e.target.value)}
                          />
                        </S.WrapperRadios>

                        {question.valueText && (
                          <S.WrapperInput>
                            <UI.Description color="gray">Caso queira, justifique sua resposta:</UI.Description>

                            <UI.InputLabel
                              style={{ width: '100%' }}
                              value={questions[question.valueText]}
                              onChange={(e) => handleChange(question.valueText, e)}
                            />
                          </S.WrapperInput>
                        )}

                        {error && questions[question.valueRadio] === '' && (
                          <S.Error style={{ marginTop: 20 }}>Selecione uma opção.</S.Error>
                        )}
                      </Fragment>
                    );
                  }

                  return '';
                })}

                {currentQuestion === 6 && (
                  <>
                    <div className="content-textarea">
                      <S.Question>
                        6) A sua opinião é muito importante para nós, por favor descreva abaixo qualquer consideração
                        que tenha em relação aos serviços prestados pela Imobiliária e/ou pela CredPago.
                      </S.Question>
                      <S.WrapperTextArea>
                        <UI.TextAreaLabel
                          value={questions.observation}
                          onChange={(e) => handleChange('observation', e.target.value)}
                          id="obervation"
                        />
                      </S.WrapperTextArea>
                    </div>
                  </>
                )}
              </S.WrapperQuestion>

              {isMobile && (
                <UI.Description color="gray" style={{ margin: '30px 0px 0px 0px' }}>
                  {currentQuestion} de 6
                </UI.Description>
              )}

              <S.WrapperButtons>
                <S.WrapperBtn>
                  <UI.Button
                    label="Voltar"
                    onClick={backQuestion}
                    type={currentQuestion === 1 ? 'link' : 'default'}
                    blocked
                  />
                </S.WrapperBtn>

                {!isMobile && (
                  <UI.Description color="gray" style={{ margin: '0px 30px 0px 30px' }}>
                    {currentQuestion} de 6
                  </UI.Description>
                )}

                <S.WrapperBtn>
                  <UI.Button
                    type={currentQuestion === 6 ? 'success' : 'primary'}
                    label={currentQuestion === 6 ? 'Enviar' : 'Avançar'}
                    onClick={currentQuestion === 6 ? handleSubmit : nextQuestion}
                    htmlType="submit"
                    blocked
                    disabled={sendingData}
                    loading={sendingData}
                  />
                </S.WrapperBtn>
              </S.WrapperButtons>
            </>
          )}
        </S.Wrapper>
      </S.Container>
    </Layout>
  );
};

export default Questions;
